import PropTypes from 'prop-types'

export const InfoCard = ({ title, items, variant = 'default', className = '' }) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'bg-dark-primary'
      case 'secondary':
        return 'bg-dark-secondary'
      case 'tertiary':
        return 'bg-dark-tertiary'
      default:
        return 'bg-dark-primary'
    }
  }

  return (
    <div className={`${getVariantClasses()} rounded-lg p-4 border border-dark-border ${className}`}>
      <h4 className="text-sm font-semibold text-white mb-2">{title}</h4>
      <ul className="text-sm text-gray-400 space-y-1">
        {items.map((item, index) => (
          <li key={`${item}-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  )
}

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'tertiary']),
  className: PropTypes.string,
}

export default InfoCard
